import convertColor from 'color-convert';
import { rgb as d3Rgb, hsl, color } from 'd3-color';
import { IColor } from '../types/IColor';

const getScaledColor = (hex: string): IColor => {
  const rgb = convertColor.hex.rgb(hex);

  const hslString = d3Rgb(rgb[0], rgb[1], rgb[2]).formatHsl();
  const hslObj = hsl(hslString);

  const hexLighter = color(`hsl(${hslObj.h}, 90%, 90%)`)?.formatHex() || '#eeeeee';
  const hexLight = color(`hsl(${hslObj.h}, 80%, 80%)`)?.formatHex() || '#cccccc';
  const hexDark = color(`hsl(${hslObj.h}, 50%, 50%)`)?.formatHex() || '#444444';
  const hexDarker = color(`hsl(${hslObj.h}, 40%, 40%)`)?.formatHex() || '#333333';

  const rgbLighter = convertColor.hex.rgb(hexLighter);
  const rgbLight = convertColor.hex.rgb(hexLight);
  const rgbDark = convertColor.hex.rgb(hexDark);
  const rgbDarker = convertColor.hex.rgb(hexDarker);

  return {
    hex, hexLight, hexLighter, hexDark, hexDarker, rgb, rgbLight, rgbDark, rgbLighter, rgbDarker,
  };
};

export default getScaledColor;
